import { useQuery, UseQueryOptions } from 'react-query';

import { CastingProjectsQueryApi } from '@lib/api/endpoints';

type UseClientEnvironmentOptions = {
  useQueryOptions?: UseQueryOptions<
    EnhancedClientEnvironment,
    unknown,
    EnhancedClientEnvironment,
    string[]
  >;
};

const defaultLogoUrl = process.env.NEXT_PUBLIC_DEFAULT_LOGO_URL;

// this can be used without authentication, because its a public endpoint
export const useClientEnvironment = (
  options: UseClientEnvironmentOptions = {}
) => {
  const { useQueryOptions = {} } = options;
  const clientEnvironmentId = Number(
    process.env.NEXT_PUBLIC_CLIENT_ENVIRONMENT_ID
  );
  const isQueryEnabled = Number.isInteger(clientEnvironmentId);
  const result = useQuery({
    queryKey: ['clientEnvironment'],
    queryFn: async (): Promise<EnhancedClientEnvironment> => {
      const environmentFromApi =
        await CastingProjectsQueryApi.getClientEnvironment(clientEnvironmentId);
      const isEveryset = environmentFromApi?.identifier === 'everyset';
      return {
        ...environmentFromApi,
        logo_url: environmentFromApi.logo_url || defaultLogoUrl,
        favicon_logo_url: environmentFromApi.favicon_logo_url || null,
        isEveryset 
      };
    },
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    enabled: isQueryEnabled,
    staleTime: 60 * 60 * 1000, // 1 hour
    ...useQueryOptions,
  });

  return result;
};
